module.exports = __webpack_public_path__ + "static/together_event02_icon03-d1bcc0754da4b9c7c69d638e4feadc35.png";